export const BASE_URL = 'https://api.chcemybycsoba.eu';
